import http from '@/utils/http'
import { list } from '@/api/url'
import { getUserId } from "@/utils/auth"

// 关联收款列表查询
export function fetchCollection(param) {
  return http({
    url: list.fetchCollection,
    method: 'post',
    data: { ...param }
  })
}

// 关联客户列表
export function fetchCustomer(param) {
  return http({
    url: list.fetchCustomer,
    method: 'post',
    data: { ...param }
  })
}
// 未开户列表
export function fetchRegisteringList(param) {
  return http({
    url: list.fetchRegisteringList,
    method: 'post',
    data: { ...param }
  })
}
// 关联客户列表
export function accountList(param) {
  return http({
    url: list.accountList,
    method: 'post',
    data: { ...param }
  })
}

// 获取growkyc信息
export function getAcctBusiness(param) {
  return http({
    url: list.getAcctBusiness,
    method: 'post',
    data: { ...param }
  })
}
// 保存growkyc信息
export function saveAcctBusiness(param) {
  return http({
    url: list.saveAcctBusiness,
    method: 'post',
    data: { ...param }
  })
}

// 关联客户列表模糊查询,下拉菜单数据
export function listByAcctName(param) {
  return http({
    url: list.listByAcctName,
    method: 'post',
    data: { ...param }
  })
}

// 关联交易列表
export function fetchPayment(param) {
  return http({
    url: list.fetchPayment,
    method: 'post',
    data: { ...param }
  })
}

// 销售结算列表
export function fetchSalesSettlement(param) {
  return http({
    url: list.salesSettlementList,
    method: 'post',
    data: { ...param }
  })
}
